import React from 'react';
import { Card, Skeleton, Stack } from '@piwikpro/ui-components';
import styles from './LoadingContent.module.css';

const LoadingContent = () => (
  <>
    <Stack vertical spacing="wide" horizontalAlignment="middle">
      <Stack.Item>
        <Skeleton width="382px" height="34px" roundBorder />
      </Stack.Item>
      <Stack.Item previousSpacing="default">
        <Stack vertical spacing="extraNarrow" horizontalAlignment="middle">
          <Stack.Item>
            <Skeleton width="446px" height="14px" roundBorder />
          </Stack.Item>
          <Stack.Item>
            <Skeleton width="614px" height="14px" roundBorder />
          </Stack.Item>
        </Stack>
      </Stack.Item>
      <Stack.Item previousSpacing="extraWide" fill>
        <Skeleton width="100%" height="32px" roundBorder />
      </Stack.Item>
      <Stack.Item />
    </Stack>
    <div className={styles.cardPaddingsOverwrite}>
      <Card connected>
        <Card.Section subdued>
          <Stack verticalAlignment="center">
            <Stack.Item>
              <Skeleton width="32px" height="32px" roundBorder />
            </Stack.Item>
            <Stack.Item fill>
              <Stack vertical spacing="extraNarrow">
                <Stack.Item>
                  <Skeleton width="240px" height="17px" roundBorder />
                </Stack.Item>
                <Stack.Item>
                  <Skeleton width="452px" height="17px" roundBorder />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Skeleton width="40px" height="16px" roundBorder />
            </Stack.Item>
          </Stack>
        </Card.Section>
      </Card>
      <Card connected>
        <Card.Section>
          <Stack verticalAlignment="center">
            <Stack.Item>
              <Skeleton width="32px" height="32px" roundBorder />
            </Stack.Item>
            <Stack.Item fill>
              <Stack vertical spacing="extraNarrow">
                <Stack.Item>
                  <Skeleton width="240px" height="17px" roundBorder />
                </Stack.Item>
                <Stack.Item>
                  <Skeleton width="452px" height="17px" roundBorder />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Skeleton width="40px" height="16px" roundBorder />
            </Stack.Item>
          </Stack>
        </Card.Section>
      </Card>
      <Card connected>
        <Card.Section>
          <Stack verticalAlignment="center">
            <Stack.Item>
              <Skeleton width="32px" height="32px" roundBorder />
            </Stack.Item>
            <Stack.Item fill>
              <Stack vertical spacing="extraNarrow">
                <Stack.Item>
                  <Skeleton width="240px" height="17px" roundBorder />
                </Stack.Item>
                <Stack.Item>
                  <Skeleton width="452px" height="17px" roundBorder />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Skeleton width="40px" height="16px" roundBorder />
            </Stack.Item>
          </Stack>
        </Card.Section>
      </Card>
    </div>
    <Card connected>
      <Card.Section>
        <Stack verticalAlignment="center">
          <Stack.Item>
            <Skeleton width="32px" height="32px" roundBorder />
          </Stack.Item>
          <Stack.Item fill>
            <Stack vertical spacing="extraNarrow">
              <Stack.Item>
                <Skeleton width="240px" height="17px" roundBorder />
              </Stack.Item>
              <Stack.Item>
                <Skeleton width="452px" height="17px" roundBorder />
              </Stack.Item>
            </Stack>
          </Stack.Item>
          <Stack.Item>
            <Skeleton width="40px" height="16px" roundBorder />
          </Stack.Item>
        </Stack>
      </Card.Section>
    </Card>
    <Card>
      <Skeleton width="100%" height="32px" roundBorder />
    </Card>
  </>
);

export default LoadingContent;
